import { normalize } from 'normalizr';

import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import {
  ThirdPartyCustomerRelationship,
  thirdPartyCustomerRelationshipSchema,
} from '@sophocles/entities/ThirdPartyCustomerRelationship/thirdPartyCustomerRelationshipRecord';
import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_THIRD_PARTY_CUSTOMER_RELATIONSHIPS = 'RECEIVE_THIRD_PARTY_CUSTOMER_RELATIONSHIPS';
function receiveThirdPartyCustomerRelationships(json) {
  return {
    type: RECEIVE_THIRD_PARTY_CUSTOMER_RELATIONSHIPS,
    thirdPartyCustomerRelationships: mapListToRecords(json, ThirdPartyCustomerRelationship),
  };
}

/* Request Actions */
// starter request
export const REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIP = 'REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIP';
function requestThirdPartyCustomerRelationship(thirdPartyCustomerRelationship_id) {
  return {
    type: REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIP,
    thirdPartyCustomerRelationship_id,
  };
}

export const REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER =
  'REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER';
function requestThirdPartyCustomerRelationshipsForCustomer(customer_id) {
  return {
    type: REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER,
    customer_id,
  };
}

export const REQUEST_DIGITAL_VENDORS_FOR_CUSTOMER = 'REQUEST_DIGITAL_VENDORS_FOR_CUSTOMER';
function requestDigitalVendorsForCustomer(customer_id) {
  return {
    type: REQUEST_DIGITAL_VENDORS_FOR_CUSTOMER,
    customer_id,
  };
}
/* Fetch Actions */
// starter fetch

export function fetchThirdPartyCustomerRelationship(thirdPartyCustomerRelationship_id) {
  return dispatch => {
    dispatch(requestThirdPartyCustomerRelationship(thirdPartyCustomerRelationship_id));
    return apiClient
      .get(`/thirdpartycustomerrelationships/${thirdPartyCustomerRelationship_id}/`)
      .then(checkHttpStatus)
      .then(response =>
        normalizeList(response.data, 'thirdPartyCustomerRelationships', thirdPartyCustomerRelationshipSchema),
      )
      .then(json => dispatch(receiveThirdPartyCustomerRelationships(json.entities.thirdPartyCustomerRelationships)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIP)));
  };
}

export function fetchThirdPartyCustomerRelationshipForCustomer(customer_id) {
  return dispatch => {
    dispatch(requestThirdPartyCustomerRelationship(customer_id));
    return (
      apiClient
        .get(`/customers/${customer_id}/thirdparties/`)
        .then(checkHttpStatus)
        .then(response =>
          normalizeList(response.data, 'thirdPartyCustomerRelationships', thirdPartyCustomerRelationshipSchema),
        )
        // .then(json => dispatch(receiveThirdPartyCustomerRelationships(json.entities.thirdPartyCustomerRelationships)))
        .then(json => json.entities.thirdParties)
        .catch(error => dispatch(genericErrorAction(error, REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER)))
    );
  };
}

export function fetchDigitalVendorsForCustomer(customer_id) {
  return dispatch => {
    dispatch(requestDigitalVendorsForCustomer(customer_id));
    return apiClient
      .get(`/customers/${customer_id}/thirdparties/?limit=1000`)
      .then(checkHttpStatus)
      .then(response =>
        normalizeList(response.data, 'thirdPartyCustomerRelationships', thirdPartyCustomerRelationshipSchema),
      )
      .then(json => json.entities.thirdParties)
      .catch(error => dispatch(genericErrorAction(error, REQUEST_DIGITAL_VENDORS_FOR_CUSTOMER)));
  };
}

/* Edit Actions */
export const EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIP = 'EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIP';
export function editThirdPartyCustomerRelationship(thirdPartyCustomerRelationship_id) {
  return {
    type: EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIP,
    thirdPartyCustomerRelationship: thirdPartyCustomerRelationship_id,
  };
}

export function patchThirdPartyCustomerRelationship(thirdPartyCustomerRelationship_id, values) {
  return dispatch => {
    dispatch(editThirdPartyCustomerRelationship(thirdPartyCustomerRelationship_id));
    return apiClient
      .patch(`/thirdpartycustomerrelationships/${thirdPartyCustomerRelationship_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, thirdPartyCustomerRelationshipSchema))
      .then(json => dispatch(receiveThirdPartyCustomerRelationships(json.entities.thirdPartyCustomerRelationships)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIP)));
  };
}

export const BULK_EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER =
  'BULK_EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER';
export function bulkSayEditThirdPartyCustomerRelationshipsForCustomer(customer_id) {
  return {
    type: BULK_EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER,
    customer_id,
  };
}

export function bulkEditThirdPartyCustomerRelationshipsForCustomer(customer_id, values) {
  return dispatch => {
    dispatch(bulkSayEditThirdPartyCustomerRelationshipsForCustomer(customer_id));
    return (
      apiClient
        .post(`/customers/${customer_id}/thirdparties/`, values)
        .then(checkHttpStatus)
        .then(response =>
          normalizeList(response.data, 'thirdPartyCustomerRelationships', thirdPartyCustomerRelationshipSchema),
        )
        // .then(response => normalize(response.data, thirdPartyCustomerRelationshipSchema))
        // .then(json => dispatch(receiveThirdPartyCustomerRelationships(json.entities.thirdPartyCustomerRelationships)))
        .then(json => {
          dispatch(
            addToast({
              title: 'Success',
              message: 'Allowed third parties updated',
              level: 'success',
              dismissible: true,
            }),
          );
          return json.entities.thirdParties;
        })
        .catch(error => dispatch(genericErrorAction(error, BULK_EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER)))
    );
  };
}

/* Create Actions */
export const CREATE_THIRD_PARTY_CUSTOMER_RELATIONSHIP = 'CREATE_THIRD_PARTY_CUSTOMER_RELATIONSHIP';
function sayCreateThirdPartyCustomerRelationship(values) {
  return {
    type: CREATE_THIRD_PARTY_CUSTOMER_RELATIONSHIP,
    values: values,
  };
}

export function createThirdPartyCustomerRelationship(values) {
  return dispatch => {
    dispatch(sayCreateThirdPartyCustomerRelationship(values));
    return apiClient
      .post(`/thirdpartycustomerrelationships/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, thirdPartyCustomerRelationshipSchema))
      .then(json => dispatch(receiveThirdPartyCustomerRelationships(json.entities.thirdPartyCustomerRelationships)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_THIRD_PARTY_CUSTOMER_RELATIONSHIP)));
  };
}

/* Delete Actions */
export const DELETE_THIRD_PARTY_CUSTOMER_RELATIONSHIP = 'DELETE_THIRD_PARTY_CUSTOMER_RELATIONSHIP';
function sayDeleteThirdPartyCustomerRelationship(thirdPartyCustomerRelationship_id) {
  return {
    type: DELETE_THIRD_PARTY_CUSTOMER_RELATIONSHIP,
    thirdPartyCustomerRelationship: thirdPartyCustomerRelationship_id,
  };
}

export function deleteThirdPartyCustomerRelationship(thirdPartyCustomerRelationship_id) {
  return dispatch =>
    apiClient
      .delete(`/thirdpartycustomerrelationships/${thirdPartyCustomerRelationship_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteThirdPartyCustomerRelationship(thirdPartyCustomerRelationship_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_THIRD_PARTY_CUSTOMER_RELATIONSHIP)));
}
